import { EventGroup } from '@/api/enumerations';
import { datetimeFormatHeader, myHeadersWithToken } from '@/api/global';
import { getCompanySubdomain } from '@/helpers';
import { getLocalStorageToken } from '@/helpers/localStorage';
import { useEffect, useState } from 'react';

type ExchangeResponse = {
  expires_in: number;
  oversight_jwt: string;
  role: string;
};

const FIFTEEN_MINUTES = 15 * 60 * 1000;
const BASE_URL =
  process.env.REACT_APP_OVERSIGHT_BASE_URL ||
  'https://oversight.protoai.com.br/api/v1';

export function useTokenRefresh(): {
  ready: boolean;
  oversightUserRole: string;
} {
  const [ready, setReady] = useState(false);
  const [oversightUserRole, setOversightUserRole] = useState('');
  const companySubdomain = getCompanySubdomain();
  const isRealPrice = companySubdomain.includes('realprice');

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (isRealPrice) {
      const refresh = async (): Promise<void> => {
        try {
          const token = getLocalStorageToken();
          if (!token) return;

          const headers = myHeadersWithToken(EventGroup.BACKGROUND);
          headers.delete(datetimeFormatHeader);

          const response = await fetch(`${BASE_URL}/auth/exchange`, {
            method: 'POST',
            headers,
          });

          if (!response.ok) {
            throw new Error('Falha ao obter o token do Oversight.');
          }

          const data = (await response.json()) as ExchangeResponse;
          localStorage.setItem('oversight-token', data.oversight_jwt);
          setOversightUserRole(data.role);
          setReady(true);
        } catch (error) {
          if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.warn('useTokenRefresh: exchange falhou', error);
          }
        }
      };
      refresh();
      const interval = setInterval(refresh, FIFTEEN_MINUTES);
      return () => clearInterval(interval);
    }
  }, [isRealPrice]);

  return { ready, oversightUserRole };
}
